import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const API = "https://wwwa.isepsantafe.net.ar/expedientes";
const BASE_ARCHIVOS = "https://wwwa.isepsantafe.net.ar";

const EvaluarVideoEntrevista = ({
  dni,
  procesoId,
  itemId,
  personaProcesoItemId,
  onGuardado,
}) => {
  const [cargando, setCargando] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [video, setVideo] = useState(null);
  const [item, setItem] = useState(null);
  const [nota, setNota] = useState("");
  const [observaciones, setObservaciones] = useState("");

  useEffect(() => {
    obtenerVideo();
  }, [dni, procesoId, itemId]);

  const obtenerVideo = async () => {
    try {
      setCargando(true);

      const res = await axios.post(
        `${API}/ingresos/persona-item/obtiene-video-entrevista`,
        {
          dni,
          proceso_id: procesoId,
          item_id: itemId,
        }
      );

      setVideo(res.data?.video || null);
      setItem(res.data?.item || null);

      if (res.data?.item?.resultado) {
        setNota(res.data.item.resultado);
      }

      if (res.data?.item?.observaciones) {
        setObservaciones(res.data.item.observaciones);
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "No se pudo obtener el video", "error");
    } finally {
      setCargando(false);
    }
  };

  const getUrlVideo = () => {
    if (!video?.url) return "";

    if (video.url.startsWith("http")) return video.url;

    return `${BASE_ARCHIVOS}${video.url}`;
  };

  const guardarEvaluacion = async () => {
    const notaNumero = Number(nota);

    if (Number.isNaN(notaNumero) || notaNumero < 0 || notaNumero > 10) {
      Swal.fire("Atención", "La nota debe ser un número del 0 al 10", "warning");
      return;
    }

    const confirma = await Swal.fire({
      icon: "question",
      title: "¿Guardar evaluación?",
      text: `Se guardará la nota ${notaNumero}/10`,
      showCancelButton: true,
      confirmButtonText: "Sí, guardar",
      cancelButtonText: "Cancelar",
    });

    if (!confirma.isConfirmed) return;

    try {
      setGuardando(true);

      await axios.post(`${API}/ingresos/togglePersonaItem`, {
        persona_id: dni,
        proceso_id: procesoId,
        item_id: itemId,
        tipo: "video",
        resultado: String(notaNumero),
        observaciones,
        estado: notaNumero >= 6 ? "aprobado" : "rechazado",
      });

      Swal.fire("Guardado", "La evaluación fue registrada", "success");

      if (onGuardado) onGuardado();
    } catch (error) {
      console.error(error);
      Swal.fire(
        "Error",
        error.response?.data?.mensaje || "No se pudo guardar la evaluación",
        "error"
      );
    } finally {
      setGuardando(false);
    }
  };

  if (cargando) return <p>Buscando video...</p>;

  if (!video) {
    return (
      <div style={styles.alerta}>
        Esta persona todavía no tiene video cargado.
      </div>
    );
  }

  return (
    <div style={styles.contenedor}>
      <h3 style={styles.titulo}>Evaluación de entrevista</h3>

      <div style={styles.videoBox}>
        <video
          src={getUrlVideo()}
          controls
          preload="metadata"
          style={styles.video}
        />
      </div>

      <div style={styles.info}>
        <div>
          <strong>Archivo:</strong> {video.nombre || "entrevista"}
        </div>
        <div>
          <strong>Tamaño:</strong>{" "}
          {video.size ? `${(video.size / 1024 / 1024).toFixed(2)} MB` : "-"}
        </div>
        <div>
          <strong>Estado actual:</strong> {item?.estado || "cargado"}
        </div>
        <div>
          <strong>Resultado actual:</strong> {item?.resultado || "-"}
        </div>
      </div>

      <div style={styles.form}>
        <label style={styles.label}>Nota de entrevista</label>

        <input
          type="number"
          min="0"
          max="10"
          step="1"
          value={nota}
          onChange={(e) => setNota(e.target.value)}
          placeholder="0 a 10"
          style={styles.input}
        />

        <label style={styles.label}>Observaciones</label>

        <textarea
          value={observaciones}
          onChange={(e) => setObservaciones(e.target.value)}
          placeholder="Observaciones de la entrevista..."
          rows={4}
          style={styles.textarea}
        />

        <button
          type="button"
          onClick={guardarEvaluacion}
          disabled={guardando}
          style={styles.boton}
        >
          {guardando ? "Guardando..." : "Guardar evaluación"}
        </button>
      </div>
    </div>
  );
};

const styles = {
  contenedor: {
    width: "100%",
    maxWidth: "900px",
    margin: "0 auto",
    padding: 20,
    background: "#fff",
    borderRadius: 14,
    boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
  },
  titulo: {
    marginTop: 0,
    marginBottom: 15,
  },
  videoBox: {
    width: "100%",
    background: "#111827",
    borderRadius: 12,
    overflow: "hidden",
  },
  video: {
    width: "100%",
    maxHeight: "65vh",
    background: "#111827",
  },
  info: {
    marginTop: 12,
    padding: 12,
    background: "#f9fafb",
    borderRadius: 10,
    fontSize: 14,
    display: "grid",
    gap: 5,
  },
  form: {
    marginTop: 15,
    display: "grid",
    gap: 10,
  },
  label: {
    fontWeight: 700,
  },
  input: {
    padding: 10,
    borderRadius: 8,
    border: "1px solid #ccc",
    fontSize: 16,
  },
  textarea: {
    padding: 10,
    borderRadius: 8,
    border: "1px solid #ccc",
    fontSize: 15,
    resize: "vertical",
  },
  boton: {
    border: "none",
    borderRadius: 8,
    padding: "11px 16px",
    background: "#2563eb",
    color: "#fff",
    fontWeight: 700,
    cursor: "pointer",
  },
  alerta: {
    padding: 18,
    borderRadius: 10,
    background: "#fef2f2",
    color: "#991b1b",
    fontWeight: 700,
    textAlign: "center",
  },
};

export default EvaluarVideoEntrevista;